import React, { useState } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever
} from "@mui/icons-material";

import { 
  Potence,
} from "@dndModels";
import { CHARACTER_LEVELS } from "@dndModels/Constants";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  obj: Potence;
  disabled?: boolean;
  onChange: () => void;
  onDelete: () => void;
}

export default function AbilityPotenceControlInput({ 
  obj,
  onChange,
  onDelete,
  disabled = false 
}: Props) {
  const [basic, setBasic] = useState(obj.rolls.flat.isBasic() && obj.rolls.count.isBasic() && obj.rolls.size.isBasic());

  return (
    <Grid
      container
      spacing={0}
      direction="row"
      size={{
        xs: 12
      }}>
      <Grid
        size={{
          xs: 1
        }}>
        <SelectStringBox 
          name="Level"
          options={CHARACTER_LEVELS}
          value={`${obj.level}`} 
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.level = +changed;
            onChange();
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 2
        }}>
        <ToggleButtonBox 
          name="Basic"
          value={basic} 
          disabled={disabled}
          onToggle={() => {
            if (!basic) {
              const new_obj = obj;
              new_obj.rolls.flat.makeBasic();
              new_obj.rolls.count.makeBasic();
              new_obj.rolls.size.makeBasic();
              onChange();
            }
            setBasic(!basic);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 8
        }}>
        <StringBox 
          name="Extra"
          value={obj.extra} 
          disabled={disabled}
          onBlur={(changed: string) => {
            const new_obj = obj;
            new_obj.extra = changed;
            onChange();
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 1
        }}>
        { !disabled &&
          <Tooltip title={`Delete Potence`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
    </Grid>
  );
}
